var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'nav-open': _vm.$sidebar.showSidebar }},[(_vm.isLoading)?_c('Loader'):_c('div',[(!_vm.isDashboardRoute && !_vm.isAuthRoute)?_c('Navbar'):_vm._e(),_c('router-view'),(!_vm.isDashboardRoute && !_vm.isAuthRoute)?_c('Footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }